// The person who writes and reviews the briefings. Change the name or
// credential here and every byline and the article structured data follow.
export const AUTHOR = {
  name: "Vanessa Challess",
  credential: "Solicitor, qualified 2003",
  jobTitle: "Practising Solicitor & Founder of Electra HR",
  path: "/about",
};
